import NOTIFICATION_API from "../Api/Notifications";
export default {
    state: {
        notifications: [], // Массив новостей
        notificationCurrentPage: 0, // Текущая страница
        notificationsLoading: false, // Состояние загрузки
        notificationTotal: null,
        notificationsUnreadCount: 0,
    },
    mutations: {
        SET_NOTIFICATIONS(state, notifications) {
            state.notifications = [...state.notifications, ...notifications];
        },
        SET_CURRENT_NOTIFICATIONS_PAGE(state, page) {
            state.notificationCurrentPage = page;
        },
        SET_LOADING_NOTIFICATIONS(state, loading) {
            state.notificationsLoading = loading;
        },
        SET_TOTAL_NOTIFICATIONS(state, notificationTotal) {
            state.notificationTotal = notificationTotal;
        },
        SET_UNREAD_NOTIFICATIONS_COUNT(state, count) {
            state.notificationsUnreadCount = count;
        },
        SET_NOTIFICATION_READ(state, notification) {
            const index = state.notifications.findIndex(
                (item) => item.id === notification.id
            );
            if (index !== -1) {
                if (state.notifications[index].is_read) {
                    return;
                }
                state.notifications[index].is_read = true;
                state.notificationsUnreadCount -= 1;
            }
        },
        SET_CLEAR_NOTIFICATIONS(state) {
            state.notifications = [];
            state.notificationCurrentPage = 0;
            state.notificationsLoading = false;
            state.notificationsUnreadCount = 0;
            state.notificationTotal = null;
        },
    },
    actions: {
        async fetchNotifications({ commit, state }) {
            if (
                (state.notifications.length &&
                    state.notifications.length === state.notificationTotal) ||
                state.notificationsLoading
            ) {
                return;
            }

            commit("SET_LOADING_NOTIFICATIONS", true);
            commit(
                "SET_CURRENT_NOTIFICATIONS_PAGE",
                state.notificationCurrentPage + 1
            );
            try {
                const response = await NOTIFICATION_API.getAllNotifications(
                    state.notificationCurrentPage
                );

                commit("SET_NOTIFICATIONS", response.notifications);
                commit("SET_TOTAL_NOTIFICATIONS", response.total_count);
                commit("SET_UNREAD_NOTIFICATIONS_COUNT", response.unread_count);
            } catch (error) {
                console.error("Error fetching notifications:", error);
            } finally {
                commit("SET_LOADING_NOTIFICATIONS", false);
            }
        },
    },
    getters: {
        notifications: (state) => state.notifications,
        notificationCurrentPage: (state) => state.notificationCurrentPage,
        notificationsLoading: (state) => state.notificationsLoading,
        notificationsUnreadCount: (state) => state.notificationsUnreadCount,
    },
};
